import { Link } from "react-router-dom";
import { Row, Col } from "react-flexbox-grid";
import { useWindowSize } from "hooks";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";

export const SingleCard = ({ title, icon, to, onClick }) => {
  const { width } = useWindowSize();
  const isMobile = width <= 425;

  return (
    <Col md={4} className="pt3">
      <Card>
        <CardActionArea>
          <CardContent component={Link} to={to} onClick={onClick}>
            <Row>
              <Col xs={6}>
                <Row
                  start="xs"
                  middle="xs"
                  className="h-100 pl4"
                  style={{ maxWidth: isMobile ? "100%" : 132 }}
                >
                  <Typography variant="body1" component="p" className="black">
                    {title}
                  </Typography>
                </Row>
              </Col>
              <Col xs={6}>
                <Row center="xs">
                  <img src={icon} alt="cover" />
                </Row>
              </Col>
            </Row>
          </CardContent>
        </CardActionArea>
      </Card>
    </Col>
  );
};
